/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";

import ListingDetail from "./ListingDetail";

/* Render listing-detail app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<ListingDetail {...props} />, document.getElementById("react"));
}
render(window.reactProps);
